import { Routes } from '@angular/router';
import { DatabetComponent } from './databet/databet.component';
import { HealthComponent } from './health/health.component'; 

export const routes: Routes = [
    { path: 'databet', component: DatabetComponent },
    { path: 'health', component: HealthComponent }
];
